<template>
  <v-autocomplete
    dense
    outlined
    clearable
    label="المؤلفون"
    prepend-icon="mdi-tie"
    multiple
    item-value="id"
    item-text="name"
    :items="autocomplete.list"
    :loading="autocomplete.loading"
    :search-input.sync="autocomplete.searchInput"
    :value="autocomplete.record"
    @input="$emit('input', $event)"
    :error-messages="errors"
  >
    <template v-slot:item="data">
      <v-list-item-avatar>
        <img :src="data.item.image">
      </v-list-item-avatar>
      <v-list-item-title v-html="data.item.name"></v-list-item-title>
    </template>
  </v-autocomplete>
</template>


<script>
export default {
  name: 'author-input',
  props: ['record', 'errors'],


  data: function () {
    return {
      autocomplete: {
        list: [],
        loading: false,
        searchInput: '',
        record: null
      }
    };
  },


  watch: {
    'record'(record) {
      if (!record || !Array.isArray(record.authors)) return;
      this.autocomplete.list.concat(record.authors);
      this.autocomplete.record = record.authors;
    },

    'autocomplete.searchInput'(query) {
      query != '' && this.search(query);
    },

  },


  methods: {
    search(query) {
      this.autocomplete.loading = true;

      this.axios.get('/admin/authors', { params: { q: query } })
        .then((response) => {
          this.autocomplete.list = response.data.data;
        })
        .finally(() => {
          this.autocomplete.loading = false;
        });
    }
  }
}
</script>